export const collectibles = ECS.world.with('isCollectible');
export const obstacles = ECS.world.with('isObstacle');
export const players = ECS.world.with('isPlayer');
export const cameras = ECS.world.with('isCamera');
export const collidables = ECS.world.with('isCollidable');
export const clouds = ECS.world.with('isCloud');
export const characters = ECS.world.with('isCharacter');
export const endings = ECS.world.with('isEnding');
export const crashed = ECS.world.with('isCrashed');
export const lastEnding = ECS.world.with('isEnding', 'isLast');
